import React, { useState, useEffect } from "react";
import "./FooterManager.css";
import { db } from "../firebaseConfig";
import {doc, getDoc, getDocs, setDoc,  updateDoc, deleteDoc, serverTimestamp, collection, addDoc, query, orderBy,} from "firebase/firestore";
import { Editor } from "@tinymce/tinymce-react";
import "tinymce/tinymce";
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/models/dom/model";
import "tinymce/skins/ui/oxide/skin.min.css";



const FooterManager = () => {
  const [footerInfo, setFooterInfo] = useState({
    publisher: "",
    editor: "",
    advisor: "",
  });
 const [contactInfo, setContactInfo] = useState({
  address: "",
  office: "",
  officeHours: "",
  phone: "",
  email: "",
  newsEmail: "",
  supportEmail: "",
  supportPhone: "",
  map: "",
});

  const [activeTab, setActiveTab] = useState("info");
  
  const footerPages = [
  { id: "about", name: "আমাদের সম্পর্কে" },
	 { id: "terms", name: "ব্যবহারের শর্তাবলী" },
	  { id: "privacy", name: "গোপনীয়তা নীতিমালা" },
  
];


const [selectedPage, setSelectedPage] = useState("about");

const [pageData, setPageData] = useState({
  title: "",
  content: "",
});
  
 const [panelMembers, setPanelMembers] = useState([]);

const loadPanelMembers = async () => {
  const q = query(
    collection(db, "editorial_panel"),
    orderBy("order", "asc")
  );

  const snap = await getDocs(q);

  setPanelMembers(
    snap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }))
  );
};
  
useEffect(() => {
  const loadFooterData = async () => {

    const infoSnap = await getDoc(doc(db, "footer_info", "main"));
    if (infoSnap.exists()) {
      setFooterInfo(infoSnap.data());
    }

    const contactSnap = await getDoc(doc(db, "footer_contact", "main"));
    if (contactSnap.exists()) {
     setContactInfo({
  address: "",
  office: "",
  officeHours: "",
  phone: "",
  email: "",
  newsEmail: "",
  supportEmail: "",
  supportPhone: "",
  map: "",
  ...contactSnap.data(),
});
    }

  };

  loadFooterData();
   loadPanelMembers();
}, []);



useEffect(() => {
  const loadPage = async () => {
    const snap = await getDoc(doc(db, "footer_links", selectedPage));

    if (snap.exists()) {
      setPageData(snap.data());
    } else {
      setPageData({
        title: "",
        content: "",
      });
    }
  };

  loadPage();
}, [selectedPage]);

const handleSaveInfo = async () => {
  try {
    await setDoc(
      doc(db, "footer_info", "main"),
      footerInfo,
      { merge: true }
    );

    alert("সংরক্ষণ করা হয়েছে");
  } catch (err) {
    alert("সংরক্ষণ ব্যর্থ");
  }
};

const handleSaveContact = async () => {
  try {
    await setDoc(
      doc(db, "footer_contact", "main"),
      contactInfo,
      { merge: true }
    );

    alert("যোগাযোগের তথ্য সংরক্ষণ হয়েছে");
  } catch (err) {
    alert("সংরক্ষণ ব্যর্থ");
  }
};

const handleSavePage = async () => {
  try {
    await setDoc(
      doc(db, "footer_links", selectedPage),
      {
        ...pageData,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    alert("তথ্য সংরক্ষণ হয়েছে");
  } catch (err) {
    alert("সংরক্ষণ ব্যর্থ");
  }
};

const [panelMember, setPanelMember] = useState({
  name: "",
  designation: "",
   bio: "",
  email: "",
  phone: "",
  order: 1,
    photo: "",
});

const handleImageUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("image", file);

  const apiKey = "874aba0b22e62f51c225a6c83f3f6da5";

  try {
    const response = await fetch(
      `https://api.imgbb.com/1/upload?key=${apiKey}`,
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await response.json();

 setPanelMember((prev) => ({
  ...prev,
  photo: data.data.url,
}));

alert("ছবি সফলভাবে আপলোড হয়েছে।");
  } catch (err) {
    alert("ছবি আপলোড ব্যর্থ!");
  }
};

const handleSavePanel = async () => {
  try {
    if (editingId) {
      await updateDoc(
        doc(db, "editorial_panel", editingId),
        panelMember
      );

      alert("তথ্য আপডেট হয়েছে");
      setEditingId(null);

    } else {
      await addDoc(
        collection(db, "editorial_panel"),
        panelMember
      );

      alert("সদস্য সংরক্ষণ হয়েছে");
    }

    await loadPanelMembers();

    setPanelMember({
      name: "",
      designation: "",
      bio: "",
      email: "",
      phone: "",
      order: 1,
	   photo: "",
    });

  } catch (err) {
    console.error(err);
    alert("সংরক্ষণ ব্যর্থ");
  }
};
const thStyle = {
  border: "1px solid #ddd",
  padding: "6px",
  textAlign: "left",
  fontSize: "14px",
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "6px",
  fontSize: "13px",
  verticalAlign: "middle",
};

const [editingId, setEditingId] = useState(null);

const handleEdit = (member) => {
  setPanelMember({
    name: member.name || "",
    designation: member.designation || "",
    bio: member.bio || "",
    email: member.email || "",
    phone: member.phone || "",
    order: member.order || 1,
	  photo: member.photo || "",
  });

  setEditingId(member.id);
};

const handleDelete = async (id) => {
  if (!window.confirm("সদস্যটি মুছে ফেলবেন?")) return;

  await deleteDoc(doc(db, "editorial_panel", id));

  await loadPanelMembers();
};



  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ marginTop: 0, color: "#000000" }}>
        ফুটার ম্যানেজমেন্ট
      </h2>

      {/* Top Tabs */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "20px",
          borderBottom: "2px solid #eee",
          paddingBottom: "12px",
          flexWrap: "wrap",
        }}
      >
        <button
		 type="button"
          className={`footer-tab ${activeTab === "info" ? "active" : ""}`}
          onClick={() => setActiveTab("info")}
        >
          সম্পাদকীয় তথ্য
        </button>

        <button
		 type="button"
          className={`footer-tab ${activeTab === "contact" ? "active" : ""}`}
          onClick={() => setActiveTab("contact")}
        >
          যোগাযোগ
        </button>

        <button
		 type="button"
          className={`footer-tab ${activeTab === "links" ? "active" : ""}`}
          onClick={() => setActiveTab("links")}
        >
          Footer Links
        </button>

        <button
		 type="button"
          className={`footer-tab ${activeTab === "panel" ? "active" : ""}`}
          onClick={() => setActiveTab("panel")}
        >
          Editorial Panel
        </button>
      </div>

      {/* Content */}
      <div className="footer-content">
       {activeTab === "info" && (
  <>
    <h3>সম্পাদকীয় তথ্য</h3>

    <div
      style={{
        display: "grid",
        gap: "15px",
        maxWidth: "600px",
      }}
    >
      <input
        className="footer-input"
        placeholder="প্রকাশক"
        value={footerInfo.publisher}
        onChange={(e) =>
          setFooterInfo({
            ...footerInfo,
            publisher: e.target.value,
          })
        }
      />

      <input
        className="footer-input"
        placeholder="সম্পাদক"
        value={footerInfo.editor}
        onChange={(e) =>
          setFooterInfo({
            ...footerInfo,
            editor: e.target.value,
          })
        }
      />

      <input
        className="footer-input"
        placeholder="উপদেষ্টা"
        value={footerInfo.advisor}
        onChange={(e) =>
          setFooterInfo({
            ...footerInfo,
            advisor: e.target.value,
          })
        }
      />

      <button
        className="footer-save-btn"
        onClick={handleSaveInfo}
      >
        সংরক্ষণ করুন
      </button>
    </div>
  </>
)}

{activeTab === "contact" && (
  <>
    <h3>যোগাযোগ</h3>

    <div
      style={{
        display: "grid",
        gap: "15px",
        maxWidth: "800px",
      }}
    >
      <h4 style={{ margin: "10px 0 0", color: "#8b0000" }}>
        প্রধান কার্যালয়
      </h4>

      <input
        className="footer-input"
        placeholder="ঠিকানা"
        value={contactInfo.address}
        onChange={(e) =>
          setContactInfo({
            ...contactInfo,
            address: e.target.value,
          })
        }
      />

      <input
        className="footer-input"
        placeholder="অফিসের নাম"
        value={contactInfo.office}
        onChange={(e) =>
          setContactInfo({
            ...contactInfo,
            office: e.target.value,
          })
        }
      />

      <input
        className="footer-input"
        placeholder="অফিস সময়"
        value={contactInfo.officeHours}
        onChange={(e) =>
          setContactInfo({
            ...contactInfo,
            officeHours: e.target.value,
          })
        }
      />

      <input
        className="footer-input"
        placeholder="ফোন"
        value={contactInfo.phone}
        onChange={(e) =>
          setContactInfo({
            ...contactInfo,
            phone: e.target.value,
          })
        }
      />

      <input
        className="footer-input"
        placeholder="ই-মেইল"
        value={contactInfo.email}
        onChange={(e) =>
          setContactInfo({
            ...contactInfo,
            email: e.target.value,
          })
        }
      />

      <h4 style={{ margin: "20px 0 0", color: "#8b0000" }}>
        সংবাদ পাঠান
      </h4>

      <input
        className="footer-input"
        placeholder="সংবাদ পাঠানোর ই-মেইল"
        value={contactInfo.newsEmail}
        onChange={(e) =>
          setContactInfo({
            ...contactInfo,
            newsEmail: e.target.value,
          })
        }
      />

      <h4 style={{ margin: "20px 0 0", color: "#8b0000" }}>
        কারিগরি সহায়তা
      </h4>

      <input
        className="footer-input"
        placeholder="সাপোর্ট ই-মেইল"
        value={contactInfo.supportEmail}
        onChange={(e) =>
          setContactInfo({
            ...contactInfo,
            supportEmail: e.target.value,
          })
        }
      />

      <input
        className="footer-input"
        placeholder="সাপোর্ট ফোন"
        value={contactInfo.supportPhone}
        onChange={(e) =>
          setContactInfo({
            ...contactInfo,
            supportPhone: e.target.value,
          })
        }
      />

      <h4 style={{ margin: "20px 0 0", color: "#8b0000" }}>
        Google Map
      </h4>

      <textarea
        className="footer-input"
        rows={3}
        placeholder="Google Maps Embed URL"
        value={contactInfo.map}
        onChange={(e) =>
          setContactInfo({
            ...contactInfo,
            map: e.target.value,
          })
        }
      />

      <button
        className="footer-save-btn"
        onClick={handleSaveContact}
      >
        সংরক্ষণ করুন
      </button>
    </div>
  </>
)}
    {activeTab === "links" && (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "240px 1fr",
      gap: "25px",
      alignItems: "flex-start",
    }}
  >
    {/* Left Menu */}
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: "6px",
        overflow: "hidden",
      }}
    >
      {footerPages.map((page) => (
        <button
          key={page.id}
          type="button"
          onClick={() => setSelectedPage(page.id)}
          style={{
            width: "100%",
            textAlign: "left",
            padding: "12px 15px",
            border: "none",
            borderBottom: "1px solid #eee",
            cursor: "pointer",
            background:
              selectedPage === page.id ? "#8b0000" : "#fff",
            color:
              selectedPage === page.id ? "#fff" : "#333",
            fontWeight: "600",
          }}
        >
          {page.name}
        </button>
      ))}
    </div>

    {/* Right Editor */}
    <div
      style={{
        display: "grid",
        gap: "15px",
      }}
    >
      <input
        className="footer-input"
        placeholder="শিরোনাম"
        value={pageData.title}
        onChange={(e) =>
          setPageData({
            ...pageData,
            title: e.target.value,
          })
        }
      />

 <Editor
  value={pageData.content}
  onEditorChange={(content) =>
    setPageData({
      ...pageData,
      content,
    })
  }
  init={{
    height: 500,
    menubar: true,

    plugins: [
      "advlist",
      "autolink",
      "lists",
      "link",
      "image",
      "charmap",
      "preview",
      "code",
      "table"
    ],

    toolbar:
      "undo redo | blocks | bold italic underline | alignleft aligncenter alignright | bullist numlist | link image | table | code",
  }}
/>
      <button
        className="footer-save-btn"
        onClick={handleSavePage}
      >
        সংরক্ষণ করুন
      </button>
    </div>
  </div>
)}


{activeTab === "panel" && (
  <>
    <h3>সম্পাদক ও প্রকাশক প্যানেল</h3>

    <div
      style={{
        maxWidth: "700px",
        display: "grid",
        gap: "15px",
      }}
    >
      <input
        className="footer-input"
        placeholder="নাম"
        value={panelMember.name}
        onChange={(e) =>
          setPanelMember({
            ...panelMember,
            name: e.target.value,
          })
        }
      />

      <input
        className="footer-input"
        placeholder="পদবি"
        value={panelMember.designation}
        onChange={(e) =>
          setPanelMember({
            ...panelMember,
            designation: e.target.value,
          })
        }
      />


<textarea
  className="footer-input"
  rows={5}
  placeholder="সংক্ষিপ্ত পরিচিতি (শিক্ষাগত যোগ্যতা, গবেষণা, প্রকাশনা, অভিজ্ঞতা ইত্যাদি)"
  value={panelMember.bio}
  onChange={(e) =>
    setPanelMember({
      ...panelMember,
      bio: e.target.value,
    })
  }
/>

      <input
        className="footer-input"
        placeholder="ই-মেইল"
        value={panelMember.email}
        onChange={(e) =>
          setPanelMember({
            ...panelMember,
            email: e.target.value,
          })
        }
      />

      <input
        className="footer-input"
        placeholder="মোবাইল"
        value={panelMember.phone}
        onChange={(e) =>
          setPanelMember({
            ...panelMember,
            phone: e.target.value,
          })
        }
      />

      <input
        className="footer-input"
        type="number"
        placeholder="ক্রম"
        value={panelMember.order}
        onChange={(e) =>
          setPanelMember({
            ...panelMember,
            order: Number(e.target.value),
          })
        }
      />

<input
  type="file"
  accept="image/*"
  onChange={handleImageUpload}
  className="footer-input"
/>

{panelMember.photo && (
  <img
    src={panelMember.photo}
    alt="Preview"
    style={{
      width: "120px",
      height: "120px",
      objectFit: "cover",
      borderRadius: "8px",
      border: "1px solid #ddd",
    }}
  />
)}


<button
  className="footer-save-btn"
  onClick={handleSavePanel}
>
  সংরক্ষণ করুন
</button>
    </div>
	
	<hr style={{ margin: "35px 0" }} />

<h3>সংরক্ষিত সদস্য</h3>

<table
  style={{
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "15px",
  }}
>
  <thead>
    <tr style={{ background: "#f5f5f5" }}>
      <th style={thStyle}>ক্রম</th>
      <th style={thStyle}>নাম</th>
      <th style={thStyle}>পদবি</th>
	  <th style={thStyle}>ছবি</th>
	  <th style={thStyle}>সংক্ষিপ্ত পরিচিতি</th>
      <th style={thStyle}>মোবাইল</th>
      <th style={thStyle}>ই-মেইল</th>
	  <th style={thStyle}>অ্যাকশন</th>
    </tr>
  </thead>

  <tbody>
    {panelMembers.map((member) => (
      <tr key={member.id}>
	  
        <td style={tdStyle}>{member.order}</td>
        <td style={tdStyle}>{member.name}</td>
        <td style={tdStyle}>{member.designation}</td>
		<td style={tdStyle}>
  <img
    src={member.photo}
    alt={member.name}
    style={{
      width: "45px",
      height: "45px",
      objectFit: "cover",
      borderRadius: "50%",
    }}
  />
</td>
		
		  <td
    style={{
      ...tdStyle,
      maxWidth: "350px",
      whiteSpace: "pre-wrap",
    }}
  >
    {member.bio}
  </td>
        <td style={tdStyle}>{member.phone}</td>
        <td style={tdStyle}>{member.email}</td>
		
		<td style={tdStyle}>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      justifyContent: "center",
    }}
  >
 <button
  type="button"
  onClick={() => handleEdit(member)}
  style={{
    cursor: "pointer",
    border: "none",
    background: "transparent",
    fontSize: "18px",
    padding: "6px",
    borderRadius: "6px",
  }}
  onMouseEnter={(e) => {
  e.currentTarget.style.background = "#8b0000";
  e.currentTarget.style.color = "#666";
}}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "transparent";
    e.currentTarget.style.transform = "scale(1)";
  }}
>
  ✏️
</button>

<button
  type="button"
  onClick={() => handleDelete(member.id)}
  style={{
    cursor: "pointer",
    border: "none",
    background: "transparent",
    fontSize: "18px",
    padding: "6px",
    borderRadius: "6px",
  }}
 onMouseEnter={(e) => {
  e.currentTarget.style.background = "#8b0000";
  e.currentTarget.style.color = "#666";
}}
  onMouseLeave={(e) => {
    e.currentTarget.style.background = "transparent";
    e.currentTarget.style.transform = "scale(1)";
  }}
>
  🗑️
</button>
</div>
</td>

      </tr>
    ))}
  </tbody>
</table>
	
  </>
)}

	</div>
    </div>
  );
};

export default FooterManager;